import { render, staticRenderFns } from "./PartnerAccountsModal.vue?vue&type=template&id=2c531c0c"
import script from "./PartnerAccountsModal.vue?vue&type=script&lang=js"
export * from "./PartnerAccountsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports